import Mock from 'mockjs';
import user from './modules/user';

const mocks = [
    ...user
];

Mock.setup({
    timeout: '800-2000',
});

export function mockXHR() {
    for (const i of mocks) {
        Mock.mock(new RegExp(i.url), i.type || 'get', i.response);
    }
}

